import { useRef, useEffect, useState, useCallback } from "react";

export default function DbRuler({
  dbMax,
  dbMin,
  font,
  fontSize,
  height,
  maxDb = 0,
  referenceLevel = 0,
}) {
  const dbRef = useRef();
  const minDb = -120; // Practical lower limit for dB
  const [dbMinVal, setDbMin] = useState(dbMin || minDb);
  const [dbMaxVal, setDbMax] = useState(dbMax || maxDb);
  const bold = `${Number(fontSize) + 2}px ${font}`;

  const drawDb = useCallback((height) => {
    if (!dbRef?.current) return;
    const ctx = dbRef.current.getContext("2d");
    ctx.clearRect(0, 0, dbRef.current.width, dbRef.current.height);

    const centerY = height / 2;

    // use height to set size variables (ie height > 200 is full)

    // Draw center line (-∞ dB)
    ctx.fillStyle = "black";
    ctx.fillRect(40, centerY, 50, 1);
    ctx.font = bold;
    ctx.fillText("-∞ dB", 4, centerY + 4);

    // Draw reference level lines (top and bottom)
    ctx.fillRect(40, 0, 50, 1);
    ctx.fillRect(40, height - 1, 50, 1);
    ctx.fillText(`${referenceLevel} dB`, 4, 12);
    ctx.fillText(`${referenceLevel} dB`, 4, height - 4);

    ctx.fillStyle = "black";
    ctx.font = bold;

    const height_3db = height * 0.25;
    const height_6db = height * 0.4;
    const height_10db = height * 0.45;

    ctx.fillRect(43, height_3db, 50, 1);
    if (height_3db > 60) {
      ctx.fillText(`${maxDb - 3} dB`, 4, height_3db + 4);
    }
    ctx.fillRect(43, height_6db, 50, 1);
    if (height_6db > 60) {
      ctx.fillText(`${maxDb - 6} dB`, 4, height_6db + 4);
    }
    ctx.fillRect(43, height_10db, 50, 1);
    if (height > 180) {
      ctx.fillText(`${maxDb - 10} dB`, 4, height_10db + 4);
    }

    ctx.fillRect(43, height - height_3db, 50, 1);
    ctx.fillText(`${maxDb - 3} dB`, 4, height - height_3db + 4);
    ctx.fillRect(43, height - height_6db, 50, 1);
    ctx.fillText(`${maxDb - 6} dB`, 4, height - height_6db + 4);
    ctx.fillRect(43, height - height_10db, 50, 1);
    if (height > 180) {
      ctx.fillText(`${maxDb - 10} dB`, 4, height - height_10db + 4);
    }
  }, [maxDb, bold, referenceLevel]);

  useEffect(() => {
    setDbMin(dbMinVal || minDb);
    setDbMax(dbMaxVal || maxDb);
  }, [dbMinVal, dbMaxVal, minDb,maxDb]);

  useEffect(() => {
    drawDb(height);
  }, [drawDb, height]);

  return (
    <div
      style={{
        position: "absolute",
        width: "50px",
        top: "0",
        left: "0",
        zIndex: "2",
      }}
    >
      <canvas
        ref={dbRef}
        width={50}
        height={height}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
}
